import { render, staticRenderFns } from "./hf28ng.vue?vue&type=template&id=08b683e0&scoped=true&"
import script from "./hf28ng.vue?vue&type=script&lang=js&"
export * from "./hf28ng.vue?vue&type=script&lang=js&"
import style0 from "./hf28ng.vue?vue&type=style&index=0&id=08b683e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b683e0",
  null
  
)

export default component.exports